export const locale = {
  lang: 'en',
  data: {
    'CHANGELOG': {
      'TITULO': 'Change Log',
      'SUBTITULO': 'Check the updates made to the platform over time',
      'ULTIMA': 'Last update',
      'CATEGORIAS': {
        'Changed': 'Updates',
        'Fixed': 'Fixes',
        'Added': 'Improvements'
      }
    },
    'KNOWLEDGE': {
      'LINK': 'Click this link if the platform does not automatically redirect you'
    }
  }
};
